import { Box, Text, Flex, Button, Container } from '@chakra-ui/react';
import NextLink from 'next/link';
import { useTranslation } from 'react-i18next';

import ArrowIcon from '@/assets/icons/ic-arrow.svg';

export const PartnerWithUnderline = () => {
  const { t } = useTranslation();

  return (
    <Box bgColor="gray.900" p={12} textAlign="center">
      <Container>
        <Flex color="white" flexDirection="column" alignItems="center" margin="auto">
          <Text fontSize={{ base: '2xl', md: '3xl' }} fontFamily="heading" fontWeight="normal">
            {t('inPersonEventsPage.partnerWithUnderlineHeading.0')}
            <Text as="span" fontWeight="bold" fontFamily="heading">
              {t('inPersonEventsPage.partnerWithUnderlineHeading.1')}
            </Text>
          </Text>
          <Text maxW="800px" mt={10}>
            {t('inPersonEventsPage.partnerWithUnderlineDescription')}
          </Text>
          <Button
            as={NextLink}
            href="/contact-us/conferences"
            variant="solid"
            alignSelf="center"
            mt={8}
            rightIcon={<ArrowIcon />}
          >
            {t('newEventPage.getStarted')}
          </Button>
        </Flex>
      </Container>
    </Box>
  );
};
